import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../features/userSlice";

import { useMsal } from "@azure/msal-react";
import { Spinner } from "../components/UI/States";

const Logout = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  useEffect(() => {
    const logoutUser = async () => {
      // Dispatch your logout action to clear user state
      dispatch(logout());

      try {
        // Call the MSAL logout method
        await instance.logoutPopup(); // or instance.logoutRedirect();
      } catch (error) {
        console.error("Logout error:", error);
      }
    };

    logoutUser();
  }, [dispatch, instance]);

  return (
    <div className="app-page flex min-h-screen items-center justify-center px-4">
      <div className="app-card flex flex-col items-center rounded-[1.75rem] border px-10 py-8 text-center">
        <Spinner />
        <p className="mt-4 font-semibold">Signing you out…</p>
        <p className="app-muted mt-1 text-sm">
          Finish in the Microsoft window if one opens.
        </p>
      </div>
    </div>
  );
};

export default Logout;
